/**
 * Access / role type for restricted components.
 */
export enum AccessType {
  NURSE = 'nurse',
  PRESCRIBER = 'prescriber',
  PHARMACY = 'pharmacy',
}
